export class  AccessibilitaDisabili {
    id?: number;
    name?: string;
    selected?: boolean;

    constructor () {}
}
